import { render } from "./Chat.vue?vue&type=template&id=4c13f9fa"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=4c13f9fa&lang=scss"
script.render = render

export default script